import React from 'react';
import { stripHtml } from '../utils/caretUtils';

/**
 * Ghost preview shown under the cursor while dragging a block.
 */
export function BlockDragOverlay({ activeBlock }) {
  if (!activeBlock) return null;

  const isMedia =
    activeBlock.type === 'image' || activeBlock.type === 'video';

  return (
    <div
      className={[
        'block-drag-overlay',
        isMedia ? 'block-drag-overlay--image' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {activeBlock.type === 'image' &&
      (activeBlock.props?.publicUrl || activeBlock.props?.localPreviewUrl) ? (
        <div className="block-preview block-preview--image-wrap">
          <img
            className="block-preview block-preview--image"
            src={
              activeBlock.props.publicUrl || activeBlock.props.localPreviewUrl
            }
            alt=""
            draggable={false}
          />
        </div>
      ) : activeBlock.type === 'video' ? (
        <div className="block-preview">
          {activeBlock.props?.provider
            ? `${activeBlock.props.provider} video`
            : 'video block'}
        </div>
      ) : (
        <div className="block-preview">
          {stripHtml(activeBlock.content).slice(0, 60) ||
            `${activeBlock.type} block`}
        </div>
      )}
    </div>
  );
}
